import type { TableSearchParameters } from '@/ui/Table/tableProperties';
import type { ColumnsAvailableProps } from '@/ui/Table/useColumnsFilter';
import useColumnsFilter from '@/ui/Table/useColumnsFilter';
import TableColumnStorage from '@/util/localStorage/TableColumnStorage';
import type { FileContentServiceFragmentFragment } from '@/graphql/generated/graphql';
import { protolusColumnsAvailable, protolusColumnsOrder } from '~/ui/Table/protulus/protolusColumns';

type Columns = keyof FileContentServiceFragmentFragment;

const columnsOrder: Columns[] = [
  'id',
  'service',
  'status',
  'job_id',
  'job_next_action',
  'processing_seconds',
  'error_response',
  ...protolusColumnsOrder,
];

const storage = new TableColumnStorage<Columns[]>('fileContentServices', [
  'id',
  'service',
  'status',
  'job_id',
  'job_next_action',
  'processing_seconds',
  'error_response',
]);

const columnsAvailables: ColumnsAvailableProps<Columns> = {
  id: {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 10,
    sorter: true,
  },
  service: {
    title: 'Content Type',
    dataIndex: 'service',
    key: 'service',
    width: 10,
    sorter: true,
  },
  status: {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 10,
    sorter: true,
  },
  job_id: {
    title: 'Job ID',
    dataIndex: 'job_id',
    key: 'job_id',
    width: 10,
    sorter: true,
  },
  job_next_action: {
    title: 'Job Next Action',
    dataIndex: 'job_next_action',
    key: 'job_next_action',
    width: 10,
    sorter: true,
  },
  processing_seconds: {
    title: 'Processing Seconds',
    dataIndex: 'processing_seconds',
    key: 'processing_seconds',
    width: 10,
    sorter: true,
  },
  error_response: {
    title: 'Error Response',
    dataIndex: 'error_response',
    key: 'error_response',
    width: 10,
  },
  ...protolusColumnsAvailable,
};

interface FileContentsColumnsArgs {
  orderBy: TableSearchParameters['orderBy'];
}

const useFileContentsColumns = ({ orderBy }: FileContentsColumnsArgs) => {
  const columns = useColumnsFilter({
    orderBy,
    storage,
    columnsOrder,
    columnsAvailables,
  });
  return columns;
};

export default useFileContentsColumns;
